import { render, staticRenderFns } from "./usvn-opition.vue?vue&type=template&id=55f3da0a&"
import script from "./usvn-opition.vue?vue&type=script&lang=js&"
export * from "./usvn-opition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports